import React from 'react';
import { t } from '@lingui/macro';

import CarouselLeftSmall from '@rover/icons/svg/carousel-left-small.svg';
import CarouselRightSmall from '@rover/icons/svg/carousel-right-small.svg';
import { Flex } from '@rover/kibble/core';
import Button from '@rover/kibble/core/Button';

export enum PaginateDirection {
  NEXT = 1,
  PREVIOUS = -1,
}

type Props = React.ComponentProps<typeof Flex> & {
  currentPage: number;
  totalPages: number;
  canPaginateNext: boolean;
  canPaginatePrevious: boolean;
  hideNumbers?: boolean;
  handlePageChange: (direction: PaginateDirection) => void;
};

const Stepper: React.FC<Props> = ({
  handlePageChange,
  currentPage,
  totalPages,
  canPaginateNext,
  canPaginatePrevious,
  hideNumbers = false,
  ...flexProps
}) => {
  return (
    <Flex
      minWidth="15x"
      gap="5x"
      flex="none"
      alignItems="center"
      justifyContent={['center', 'right']}
      {...flexProps}
    >
      <Button
        data-qa-id="paginate-previous"
        data-testid="paginate-previous"
        icon={CarouselLeftSmall}
        disabled={!canPaginatePrevious}
        circular
        aria-label={t`paginate previous`}
        onClick={() => handlePageChange(PaginateDirection.PREVIOUS)}
      />
      {!hideNumbers && `${currentPage} / ${totalPages}`}
      <Button
        data-qa-id="paginate-next"
        data-testid="paginate-next"
        icon={CarouselRightSmall}
        disabled={!canPaginateNext}
        circular
        aria-label={t`paginate next`}
        onClick={() => handlePageChange(PaginateDirection.NEXT)}
      />
    </Flex>
  );
};

export default Stepper;
